import {
    browserSupportsWebAuthn,
    startAuthentication,
    type AuthenticationResponseJSON,
    type PublicKeyCredentialRequestOptionsJSON,
} from '@simplewebauthn/browser'
import { useLocation } from 'react-router'

export interface PasskeyAuthenticationStart {
    ceremonyId: string
    options: PublicKeyCredentialRequestOptionsJSON
}

export const passkeysSupported = () => browserSupportsWebAuthn()

export const usePasskeyEnrollmentPrompt = () =>
    (useLocation().state as { promptPasskey?: unknown } | null)?.promptPasskey === true && passkeysSupported()

/** Runs passkey authentication and releases the challenge if the browser ceremony is abandoned. */
export const authenticateWithPasskey = async <T>(
    begin: () => Promise<PasskeyAuthenticationStart>,
    complete: (body: { ceremonyId: string; response: AuthenticationResponseJSON }) => Promise<T>,
    abandon: (ceremonyId: string) => Promise<void>
) => {
    const { ceremonyId, options } = await begin()
    let response: AuthenticationResponseJSON
    try {
        response = await startAuthentication({ optionsJSON: options })
    } catch (error) {
        await abandon(ceremonyId).catch(() => undefined)
        throw error
    }
    return await complete({ ceremonyId, response })
}
